import React, { useContext, useState } from "react";
import arrow from "../../Assets/Icons/utilIcons/Arrow_drop.svg";
import { DeltaContext } from "../../Contexts/DeltaContext";
function DropMenu(props) {
  const { screenSize } = useContext(DeltaContext);
  const { title, notop, initial } = props;
  const [deployed, setDeployed] = useState(initial);
  const borderTop = notop ? "none" : "solid 4px #d9d9d9";
  const height = "92px";
  const styles = {
    compu: {
      paddingLeft: "96px",
      paddingRight: "64px",
      fontSize: "38px",
      color: "#364660",
      borderTop: borderTop,
      height: height,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    tablet: {
      paddingLeft: "64px",
      paddingRight: "64px",
      fontSize: "24px",
      color: "#364660",
      borderTop: borderTop,
      height: height,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    celu: {
      paddingLeft: "64px",
      paddingRight: "40px",
      fontSize: "19px",
      color: "#364660",
      borderTop: borderTop,
      height: height,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  };
  return (
    <div style={{ borderBottom: "4px solid #d9d9d9" }}>
      <div
        className={deployed ? "menuTitle menuDeploy" : "menuTitle"}
        onClick={deployed ? () => setDeployed(false) : () => setDeployed(true)}
        style={
          screenSize.width > 950
            ? styles.compu
            : screenSize.width > 600
            ? styles.tablet
            : styles.celu
        }
      >
        <p>{title}</p>
        <img
          style={
            deployed
              ? {
                  transition: "0.5s",
                  transform: "rotate(180deg)",
                }
              : {
                  transition: "0.5s",
                  transform: "rotate(0deg)",
                }
          }
          src={arrow}
          alt="open"
        />
      </div>
      {deployed ? props.children : null}
    </div>
  );
}

export { DropMenu };
